import React from "react";
import { Checkbox } from "antd";

const AdminPermission = () => {
  return (
    <>
      <div className="page_header">
        <h4>Admin Permission</h4>
      </div>
      <div className="admin_permission_he">
        <span className="admin_prs_name">manojnalla04@gmail.com</span>
        <div className="analytical_btn">SAVE</div>
      </div>

      <div className="persmission_container">
        <div className="permission_box">
          <div className="prs_box_header">
            <div className="prs_left_title">
              <span className="left_sp_titl">Menu</span>
            </div>
            <div className="prs_right_title">
              <span>Sellect All</span>
              <Checkbox className="custom-checkbox" />
            </div>
          </div>
          <div className="list_box_prs_ad">
            <ul>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">LIST</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">CREATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">UPDATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">DELETE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">BLOCK</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="permission_box">
          <div className="prs_box_header">
            <div className="prs_left_title">
              <span className="left_sp_titl">RESTAURANTS</span>
            </div>
            <div className="prs_right_title">
              <span>Sellect All</span>
              <Checkbox className="custom-checkbox" />
            </div>
          </div>
          <div className="list_box_prs_ad">
            <ul>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">LIST</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">CREATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">UPDATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">BLOCK</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="permission_box">
          <div className="prs_box_header">
            <div className="prs_left_title">
              <span className="left_sp_titl">ORDERS</span>
            </div>
            <div className="prs_right_title">
              <span>Sellect All</span>
              <Checkbox className="custom-checkbox" />
            </div>
          </div>
          <div className="list_box_prs_ad">
            <ul>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">LIST</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>

              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">UPDATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="permission_box">
          <div className="prs_box_header">
            <div className="prs_left_title">
              <span className="left_sp_titl">PROMOTIONS</span>
            </div>
            <div className="prs_right_title">
              <span>Sellect All</span>
              <Checkbox className="custom-checkbox" />
            </div>
          </div>
          <div className="list_box_prs_ad">
            <ul>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">LIST</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">CREATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">UPDATE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">DELETE</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="permission_box">
          <div className="prs_box_header">
            <div className="prs_left_title">
              <span className="left_sp_titl">USER</span>
            </div>
            <div className="prs_right_title">
              <span>Sellect All</span>
              <Checkbox className="custom-checkbox" />
            </div>
          </div>
          <div className="list_box_prs_ad">
            <ul>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">LIST</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">BLOCK</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="permission_box">
          <div className="prs_box_header">
            <div className="prs_left_title">
              <span className="left_sp_titl">SUB ADMIN</span>
            </div>
            <div className="prs_right_title">
              <span>Sellect All</span>
              <Checkbox className="custom-checkbox" />
            </div>
          </div>
          <div className="list_box_prs_ad">
            <ul>
              <li>
                <div className="prs_left_title">
                  <span className="list_ad_prs_left">LIST</span>
                </div>
                <div className="prs_right_title">
                  <Checkbox className="custom-checkbox" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPermission;
